module.exports = __webpack_public_path__ + "7a505a789af83a250e87d03a327c8ec9.png";